import AddIcon from "@mui/icons-material/AddRounded";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { Link } from "react-router";
import useClientContext from "../../../../contexts/useClientContext";
import useClientPageTitle from "../../../../contexts/useClientPageTitle";
import { pageRoutes } from "../../../../routes";
import { workspaceInvestorSelector } from "../../../../store/state/user/selectors";
import SettingsWrapper from "../SettingsWrapper";
import ContactsList from "./ContactsList";

const ContactSettings = () => {
  useClientPageTitle("Contacts");

  const { clientCode, isFeatureEnabled } = useClientContext();
  const workspaceInvestor = useSelector(workspaceInvestorSelector);

  const canUserEdit = !!workspaceInvestor && isFeatureEnabled("MembershipEditor");

  return (
    <SettingsWrapper
      title="Contacts"
      subtitle={workspaceInvestor?.investorTitle}
      scrollOwner="children"
      maxWidth={false}
      HeaderAction={
        canUserEdit ? (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            component={Link}
            to={`/${clientCode}/${pageRoutes.settings}/lp/members/new`}
          >
            Add Contact
          </Button>
        ) : undefined
      }
    >
      <ContactsList key={workspaceInvestor?.investorId} canUserEdit={canUserEdit} />
    </SettingsWrapper>
  );
};

export default ContactSettings;
